<template>
  <div>
    <b-card title="User Managament">
      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(0, 207, 232, 0.15)'"
              class="custom-add"
              @click="onAdd"
              pill
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">{{ $t("button.new") }}</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col md="4">
          <b-form-group
            label-for="i-name"
            label="Username"
            class="title-freight"
          >
            <b-form-input id="i-name" v-model="dataFilter.strName" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label-for="i-firstname"
            :label="locals('leadcust.firstname')"
            class="title-freight"
          >
            <b-form-input id="i-firstname" v-model="dataFilter.strFirstname" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label-for="i-surname"
            :label="locals('leadcust.surname')"
            class="title-freight"
          >
            <b-form-input id="i-surname" v-model="dataFilter.strSurname" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label-for="i-email"
            label="อีเมลล์"
            class="title-freight"
          >
            <b-form-input id="i-email" v-model="dataFilter.strEmail" />
          </b-form-group>
        </b-col>
         <b-col md="4">
          <b-form-group
            :label="locals('leadcust.department2')"
            label-for="i-main"
            class="title-freight"
          >
            <v-select
              input-id="i-main"
              :clearable="true"
              v-model="dataFilter.intDeptId"
              :placeholder="locals('select.placeholder')"
              label="strDeptName"
              :reduce="(val) => val.intDeptId"
              :options="departmentOption"
              autocomplete="off"
            />
          </b-form-group>
        </b-col
        ><b-col md="4">
          <b-form-group
                :label="locals('inquiry.status')"
                label-for="i-status"
                class="title-freight"
              >
                <v-select
                  id="i-status"
                  v-model="dataFilter.strStatus"
                  :placeholder="locals('select.placeholder')"
                  input-id="i-status"
                  label="title"
                  :reduce="(val) => val.title"
                  :options="status"
                />
              </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex justify-content-center">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            class="mr-1 custom-search btn-fixed-width"
            pill
            @click="onSearch"
          >
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">{{ $t("button.search") }}</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            class="mr-1 btn-fixed-width"
            pill
            @click="onClear"
          >
            <feather-icon icon="RefreshCwIcon" class="mr-50" />
            <span class="align-middle">{{ $t("button.clear") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-overlay :show="isLoading" rounded="sm" spinner-variant="primary">
      <b-card title="รายละเอียด">
        <b-row class="pt-2">
          <b-col md="12">
            <vue-good-table
              :columns="columns"
              :rows="rows"
              :search-options="{
                enabled: false,
              }"
              :pagination-options="{
                enabled: true,
                perPage: pageLength,
              }"
              styleClass="vgt-table condensed"
            >
              <!-- Slot: Table Column -->
              <template slot="table-column" slot-scope="props">
                <span
                  v-if="props.column.label === 'Action'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.action") }}
                </span>
                <span
                  v-else-if="props.column.label === 'ชื่อจริง'"
                  class="text-nowrap"
                >
                  {{ $t("leadcust.firstname") }}
                </span>
                <span
                  v-else-if="props.column.label === 'นามสกุล'"
                  class="text-nowrap"
                >
                  {{ $t("leadcust.surname") }}
                </span>
                <span
                  v-else-if="props.column.label === 'แผนก'"
                  class="text-nowrap"
                >
                  {{ $t("leadcust.department2") }}
                </span>
                <span
                  v-else-if="props.column.label === 'ผู้สร้าง'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.create_by") }}
                </span>
                <span
                  v-else-if="props.column.label === 'วันที่สร้าง'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.create_date") }}
                </span>
                <span
                  v-else-if="props.column.label === 'ผู้แก้ไข'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.update_by") }}
                </span>
                <span
                  v-else-if="props.column.label === 'วันที่แก้ไข'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.update_date") }}
                </span>
                <span v-else>
                  {{ props.column.label }}
                </span>
              </template>
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <div class="text-center">
                    <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-warning"
                      class="btn-icon rounded-circle mr-1"
                      v-b-tooltip.hover.v-warning
                      title="Edit"
                      @click="onEdit(props.index, props.row.id)"
                    >
                      <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-danger"
                      class="btn-icon rounded-circle"
                      v-b-tooltip.hover.v-danger
                      title="Delete"
                      @click="onDelete(props.index, props.row.id)"
                    >
                      <font-awesome-icon icon="fa-solid fa-trash" />
                    </b-button>
                  </div>
                </span>
                <span v-else-if="props.column.field === 'strStatus'">
                  <div class="text-center">
                    <b-badge :variant="statusVariant(props.row.strStatus)">
                      {{ props.row.strStatus }}
                    </b-badge>
                  </div>
                </span>
                <!-- Column: Status -->
                <span v-else-if="props.column.label === 'สถานะ'">
                  <div class="text-center">
                    <b-badge :variant="statusVariant2(props.row.strActive)">
                      {{ props.row.strActive }}
                    </b-badge>
                  </div>
                </span>
                <!-- Column: Active -->
                <span v-else-if="props.column.label === 'เปิด/ปิด'">
                  <div class="text-center">
                    <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-danger"
                      class="btn-icon rounded-circle"
                      v-b-tooltip.hover.v-danger
                      title="Inactive"
                      v-if="props.row.active == 'Y'"
                      @click="handleActive(props.index, props.row.id, 'N')"
                    >
                      <font-awesome-icon icon="fa-solid fa-times-circle" />
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-success"
                      class="btn-icon rounded-circle"
                      v-b-tooltip.hover.v-success
                      title="Active"
                      v-if="props.row.active == 'N'"
                      @click="handleActive(props.index, props.row.id, 'Y')"
                    >
                      <font-awesome-icon icon="fa-solid fa-history" />
                    </b-button>
                  </div>
                </span>
              </template>
              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Showing 1 to </span>
                    <b-form-select
                      v-model="pageLength"
                      :options="['10', '20', '50', '100']"
                      class="mx-1"
                      @input="
                        (pageLength) =>
                          props.perPageChanged({
                            currentPerPage: pageLength,
                          })
                      "
                    />
                    <span class="text-nowrap">
                      of {{ props.total }} entries
                    </span>
                  </div>
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="props.total"
                      :per-page="pageLength"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @input="
                        (pageLength) =>
                          props.pageChanged({
                            currentPage: pageLength,
                          })
                      "
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import { VueGoodTable } from "vue-good-table";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BPagination,
  BBadge,
  BFormSelect,
  BOverlay,
  VBTooltip,
  VBModal,
} from "bootstrap-vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";

import Service from "@/@API/cDropdown";
import UserService from "@/@API/cUser";

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BCard,
    BInputGroup,
    vSelect,
    BInputGroupAppend,
    BButton,
    flatPickr,
    VueGoodTable,
    BPagination,
    BBadge,
    BFormSelect,
    BOverlay,
    VBTooltip,
    VBModal,
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        Draft: "light-info",
        DRAFT: "light-info",
        Submit: "light-success",
        SUBMIT: "light-success",
        Canceled: "light-danger",
      };
      return (table_status) => statusColor[table_status];
    },
    statusVariant2() {
      const statusColor2 = {
        เปิดใช้งาน: "light-info",
        ปิดใช้งาน: "light-danger",
      };
      return (table_status2) => statusColor2[table_status2];
    },
  },
  data() {
    return {
      isLoading: true,
      dataFilter: {
        intDeptId: "",
        strDepartment: "",
        strName: "",
        strFirstname: "",
        strSurname: "",
        strEmail: "",
      },
      UserOptions: [
        {
          intDsId: 1,
          strDsDesc: "คุณดิว",
        },
        {
          intDsId: 2,
          strDsDesc: "คุณกุ๊ก",
        },
        {
          intDsId: 4,
          strDsDesc: "คุณโปเต้",
        },
        {
          intDsId: 5,
          strDsDesc: "คุณเจน",
        },
        {
          intDsId: 6,
          strDsDesc: "คุณจุ๊บแจง",
        },
        {
          intDsId: 7,
          strDsDesc: "คุณนภ",
        },
        {
          intDsId: 8,
          strDsDesc: "คุณดา",
        },
        {
          intDsId: 9,
          strDsDesc: "คุณน้อง",
        },
        {
          intDsId: 10,
          strDsDesc: "คุณปุ๋ม",
        },
        {
          intDsId: 99,
          strDsDesc: "-",
        },
      ],
      departmentOption: [],
      TestOptions: [
        {
          intDsId: 1,
          strDsDesc: "TEST",
        },
        {
          intDsId: 99,
          strDsDesc: "อื่น ๆ",
        },
      ],
      serviceOption: [
        {
          intDsId: 1,
          strDsDesc: "บริการ Freight",
        },
        {
          intDsId: 2,
          strDsDesc: "บริการ Custom Broker & Domestic transportation",
        },
        {
          intDsId: 3,
          strDsDesc: "บริการ RA",
        },
        {
          intDsId: 4,
          strDsDesc: "บริการ งานกฎหมาย Legal",
        },
      ],
      MainOptions: [
        {
          intDsId: 1,
          strDsDesc: "ผลิต",
        },
        {
          intDsId: 2,
          strDsDesc: "ขนส่ง",
        },
        {
          intDsId: 3,
          strDsDesc: "บริการ",
        },
        {
          intDsId: 99,
          strDsDesc: "อื่น ๆ",
        },
      ],
      leadstage: [
        { intDsId: 1, strDsDesc: "New" },
        { intDsId: 2, strDsDesc: "Work" },
        { intDsId: 3, strDsDesc: "Unqualified" },
        { intDsId: 4, strDsDesc: "Convert" },
      ],
      ori_status: [
        { title: "เปิดใช้งาน", lang: "th_TH" },
        { title: "Active", lang: "en_US" },
        { title: "ปิดใช้งาน", lang: "th_TH" },
        { title: "Inactive", lang: "en_US" }, 
      ],
      status: [],
      table_status: [
        {
          0: "Draft",
          1: "DRAFT",
          2: "Submit",
          3: "SUBMIT",
          4: "Canceled",
        },
        {
          0: "light-info",
          1: "light-info",
          2: "light-success",
          3: "light-success",
          4: "light-danger",
        },
      ],
      table_status2: [
        {
          0: "เปิดใช้งาน",
          1: "ปิดใช้งาน",
        },
        {
          0: "light-info",
          1: "light-danger",
        },
      ],
      pageLength: 20,
      dir: false,
      codeColumnSearch: "",
      columns: [
        {
          label: "Action",
          field: "action",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Username",
          field: "username",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "สถานะ",
          field: "active",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "เปิด/ปิด",
          field: "active",
          width: "100px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อจริง",
          field: "firstname",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "นามสกุล",
          field: "surname",
          width: "250px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "แผนก",
          field: "department",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Tel No.",
          field: "telno",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Email",
          field: "email",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้สร้าง",
          field: "createdby",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่สร้าง",
          field: "createddatedmy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้แก้ไข",
          field: "updatedby",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่แก้ไข",
          field: "updateddatedmy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      rows: [],
    };
  },
  mounted() {
    localStorage.setItem("customer-id", -1);
    this.getDefault();
    this.onClear();
  },
  methods: {
    getDefault() {
      let lang = localStorage.getItem("language");
      let newstatus = [];
      newstatus = this.ori_status.filter((b) => b.lang == lang);
      this.status = newstatus;

      Service.getDepartmentDropdown({})
        .then((response) => {
          this.departmentOption = [];
          response.data.lstDepartment.forEach((cc) => {
            this.departmentOption.push(cc);
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onSearch() {
      this.isLoading = true;
      UserService.getSearchUser(this.dataFilter)
        .then((response) => {
          console.log(response.data);
          this.isLoading = false;
          let lang = localStorage.getItem("lang");
          this.rows = response.data;
          this.rows.forEach((q) => {
            q.createddatedmy = q.createddate
              ? moment(q.createddate).format("DD/MM/YYYY HH:mm")
              : null;
            q.updateddatedmy = q.updateddate
              ? moment(q.updateddate).format("DD/MM/YYYY HH:mm")
              : null;
            if (q.active == "Y") {
              q.strActive = "เปิดใช้งาน";
            } else {
              q.strActive = "ปิดใช้งาน";
            }
          });
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error", error);
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onAdd() {
      localStorage.setItem("user-id", -1);
      this.$router.replace({ name: "user-form" }).then(() => {});
    },
    onEdit(index, Id) {
      this.$router.replace({ name: "user-form" }).then(() => {
        localStorage.setItem("user-id", Id);
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "แก้ไขเอกสาร",
              icon: "EditIcon",
              variant: "warning",
              text: "กำลังแก้ไขเอกสาร",
            },
          },
          {
            position: "top-center",
          }
        );
      });
    },
    handleActive(index, Id, mode) {
      let lang = localStorage.getItem("language");

      let tttitle = "Confirm Switch";
      let msg = "Do you want to Switch this user?";
      let b1 = "Edit";
      let b2 = "Close";

      if (lang == "th_TH") {
        tttitle = "ยืนยันการสลับการใช้งาน";
        msg = "คุณต้องการสลับการใช้งานรายชื่อนี้ใช่หรือไม่ ?";
        b1 = "ปิดใช้งาน";
        b2 = "ปิด";
        if (mode == "Y") {
          b1 = "เปิดใช้งาน";
        }
      }

      let color1 = "modal-danger";
      let color2 = "danger";
      if (mode == "Y") {
        color1 = "modal-success";
        color2 = "success";
      }

      this.$bvModal
        .msgBoxConfirm(msg, {
          title: tttitle,
          size: "sm",
          modalClass: color1,
          okVariant: color2,
          okTitle: b1,
          cancelTitle: b2,
          cancelVariant: "outline-warning",
          hideHeaderClose: false,
          //centered: true,
        })
        .then((value) => {
          console.log(value);
          if (value) {
            UserService.getResponseSwitchUser({ intUserId: Id })
              .then((response) => {
                if (
                  response.data == "ไม่พบรายชื่อ" ||
                  response.data == "ไม่สามารถลบได้"
                ) {
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "Something was wrong",
                        icon: "FrownIcon",
                        variant: "danger",
                        text: response.data,
                      },
                    },
                    {
                      position: "top-center",
                    }
                  );
                } else {
                  this.onSearch();
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "แก้ไขสถานะ",
                        icon: "EditIcon",
                        variant: "warning",
                        text: "แก้ไขเรียบร้อย",
                      },
                    },
                    {
                      position: "top-center",
                    }
                  );
                }
              })
              .catch((error) => {
                console.log("error", error);
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "Something was wrong",
                      icon: "FrownIcon",
                      variant: "danger",
                      text: "Something was wrong : " + error,
                    },
                  },
                  {
                    position: "top-center",
                  }
                );
              });
          }
        });
    },
    onDelete(index, Id) {
      let lang = localStorage.getItem("language");

      let tttitle = "Confirm Delete";
      let msg = "Do you want to delete this user?";
      let b1 = "Delete";
      let b2 = "Close";

      if (lang == "th_TH") {
        tttitle = "ยืนยันการลบ";
        msg = "คุณต้องการยืนยันลบรายชื่อนี้ใช่หรือไม่ ?";
        b1 = "ลบ";
        b2 = "ปิด";
      }
      this.$bvModal
        .msgBoxConfirm(msg, {
          title: tttitle,
          size: "sm",
          modalClass: "modal-danger",
          okVariant: "danger",
          okTitle: b1,
          cancelTitle: b2,
          cancelVariant: "outline-warning",
          hideHeaderClose: false,
          //centered: true,
        })
        .then((value) => {
          console.log(value);
          if (value) {
            UserService.getResponseDeleteUser({ intUserId: Id })
              .then((response) => {
                if (
                  response.data == "ไม่พบรายชื่อ" ||
                  response.data == "ไม่สามารถลบได้"
                ) {
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "Something was wrong",
                        icon: "FrownIcon",
                        variant: "danger",
                        text: response.data,
                      },
                    },
                    {
                      position: "top-center",
                    }
                  );
                } else {
                  this.rows.splice(index, 1);
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "ลบข้อมูล",
                        icon: "XIcon",
                        variant: "success",
                        text: "ลบสำเร็จ",
                      },
                    },
                    {
                      position: "top-center",
                    }
                  );
                }
              })
              .catch((error) => {
                console.log("error", error);
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "Something was wrong",
                      icon: "FrownIcon",
                      variant: "danger",
                      text: "Something was wrong : " + error,
                    },
                  },
                  {
                    position: "top-center",
                  }
                );
              });
          }
        });
    },
    onClear() {
      this.dataFilter = {
        intDeptId: "",
        strDepartment: "",
        strName: "",
        strFirstname: "",
        strSurname: "",
        strEmail: "",
      };
      this.onSearch();
    },
    locals(key) {
      return this.t(key);
    },
  },
};
</script>

<style lang="scss">
@import "../../@core/scss/vue/libs/vue-select.scss";
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
@import "../../@core/scss/vue/libs/vue-good-table.scss";
</style>
